import { render, staticRenderFns } from "./addFile.vue?vue&type=template&id=c3a1c814&scoped=true"
import script from "./addFile.vue?vue&type=script&lang=js"
export * from "./addFile.vue?vue&type=script&lang=js"
import style0 from "./addFile.vue?vue&type=style&index=0&id=c3a1c814&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a1c814",
  null
  
)

export default component.exports